// src/DimensionnementFrigoModal.js
import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import { motion } from 'framer-motion';
import { X, Zap } from 'lucide-react';

const getProductImage = (ref) => `https://devis.takoussane.com/images/${ref}.png`;
const fmt = (n) => new Intl.NumberFormat('fr-FR').format(Math.round(n || 0));

const TYPES = [
  { key: 'frigo',       label: 'Réfrigérateur',     icon: '🧊', desc: 'Conservation 0-10°C' },
  { key: 'frigo-conge', label: 'Frigo-Congélateur',  icon: '❄️', desc: 'Double compartiment' },
  { key: 'congelateur', label: 'Congélateur Coffre',  icon: '🧊', desc: 'Congélation -18°C' },
  { key: 'vitrine',     label: 'Vitrine Réfrigérée',  icon: '🏪', desc: 'Porte vitrée commerciale' },
  { key: 'glace',       label: 'Machine à Glace',     icon: '🧊', desc: '30kg/jour DC 24V' },
];

const PRODUITS_BASE = [
  { ref: 'FRIGO-BC-50',    nom: 'Réfrigérateur Solaire 50L DC/AC',                  prix: 248700,  litres: 50,  type: 'frigo',       puissance: 50  },
  { ref: 'FRIGO-BC-90',    nom: 'Réfrigérateur Solaire 90L DC/AC',                  prix: 291300,  litres: 90,  type: 'frigo',       puissance: 65  },
  { ref: 'FRIGO-BCD-90D',  nom: 'Frigo-Congélateur Solaire 90L DC/AC',             prix: 308300,  litres: 90,  type: 'frigo-conge', puissance: 70  },
  { ref: 'FRIGO-BCD-118',  nom: 'Frigo-Congélateur Solaire 118L DC/AC',            prix: 350900,  litres: 118, type: 'frigo-conge', puissance: 75  },
  { ref: 'FRIGO-BCD-128',  nom: 'Frigo-Congélateur Solaire 128L DC/AC',            prix: 362800,  litres: 128, type: 'frigo-conge', puissance: 70  },
  { ref: 'FRIGO-BCD-142',  nom: 'Frigo-Congélateur Solaire 142L DC/AC',            prix: 356000,  litres: 142, type: 'frigo-conge', puissance: 76  },
  { ref: 'FRIGO-BCD-168',  nom: 'Frigo-Congélateur Solaire 168L DC/AC',            prix: 400300,  litres: 168, type: 'frigo-conge', puissance: 100 },
  { ref: 'FRIGO-BCD-178',  nom: 'Frigo-Congélateur Solaire 178L DC/AC',            prix: 379800,  litres: 178, type: 'frigo-conge', puissance: 85  },
  { ref: 'FRIGO-BCD-198',  nom: 'Frigo-Congélateur Solaire 198L DC/AC',            prix: 439400,  litres: 198, type: 'frigo-conge', puissance: 90  },
  { ref: 'FRIGO-BCD-218',  nom: 'Frigo-Congélateur Solaire 218L DC/AC',            prix: 419000,  litres: 218, type: 'frigo-conge', puissance: 91  },
  { ref: 'FRIGO-BCD-268',  nom: 'Frigo-Congélateur Solaire 268L DC/AC',            prix: 516100,  litres: 268, type: 'frigo-conge', puissance: 93  },
  { ref: 'FRIGO-BCD-270',  nom: 'Frigo-Congélateur Solaire 270L DC/AC',            prix: 630200,  litres: 270, type: 'frigo-conge', puissance: 98  },
  { ref: 'FRIGO-BCD-298',  nom: 'Frigo-Congélateur Solaire 298L No Frost DC/AC',   prix: 728900,  litres: 298, type: 'frigo-conge', puissance: 99  },
  { ref: 'FRIGO-BCD-338',  nom: 'Frigo-Congélateur Solaire 338L No Frost DC/AC',   prix: 815800,  litres: 338, type: 'frigo-conge', puissance: 103 },
  { ref: 'CONGE-BC-68',    nom: 'Congélateur Solaire Coffre 68L DC/AC',             prix: 281000,  litres: 68,  type: 'congelateur', puissance: 38  },
  { ref: 'CONGE-BC-88',    nom: 'Congélateur Solaire Coffre 88L DC/AC',             prix: 303200,  litres: 88,  type: 'congelateur', puissance: 43  },
  { ref: 'CONGE-BC-108',   nom: 'Congélateur Solaire Coffre 108L DC/AC',            prix: 306600,  litres: 108, type: 'congelateur', puissance: 47  },
  { ref: 'CONGE-BC-158',   nom: 'Congélateur Solaire Coffre 158L DC/AC',            prix: 325300,  litres: 158, type: 'congelateur', puissance: 49  },
  { ref: 'CONGE-BC-208',   nom: 'Congélateur Solaire Coffre 208L DC/AC',            prix: 352600,  litres: 208, type: 'congelateur', puissance: 68  },
  { ref: 'CONGE-BC-258',   nom: 'Congélateur Solaire Coffre 258L DC/AC',            prix: 374700,  litres: 258, type: 'congelateur', puissance: 78  },
  { ref: 'CONGE-BC-268',   nom: 'Congélateur Solaire Coffre 268L DC/AC',            prix: 425800,  litres: 268, type: 'congelateur', puissance: 80  },
  { ref: 'CONGE-BC-308',   nom: 'Congélateur Solaire Coffre 308L DC/AC',            prix: 432600,  litres: 308, type: 'congelateur', puissance: 95  },
  { ref: 'CONGE-BC-358',   nom: 'Congélateur Solaire Coffre 358L DC/AC',            prix: 524600,  litres: 358, type: 'congelateur', puissance: 100 },
  { ref: 'CONGE-BC-508',   nom: 'Congélateur Solaire Coffre 508L DC/AC',            prix: 694900,  litres: 508, type: 'congelateur', puissance: 115 },
  { ref: 'CONGE-BD-198',   nom: 'Congélateur Solaire Vertical 198L DC24V',          prix: 562000,  litres: 198, type: 'congelateur', puissance: 225 },
  { ref: 'CONGE-BC-558',  nom: 'Congélateur Solaire Coffre 558L DC24V',  prix: 1032100, litres: 558,  type: 'congelateur', puissance: 155 },
  { ref: 'CONGE-BC-698',  nom: 'Congélateur Solaire Coffre 698L DC24V',  prix: 1101900, litres: 698,  type: 'congelateur', puissance: 166 },
  { ref: 'CONGE-BC-798',  nom: 'Congélateur Solaire Coffre 798L DC24V',  prix: 1163200, litres: 798,  type: 'congelateur', puissance: 189 },
  { ref: 'CONGE-BC-1088', nom: 'Congélateur Solaire Coffre 1088L DC24V', prix: 1546400, litres: 1088, type: 'congelateur', puissance: 223 },
  { ref: 'CONGE-BC-1388', nom: 'Congélateur Solaire Coffre 1388L DC24V', prix: 1634900, litres: 1388, type: 'congelateur', puissance: 255 },
  { ref: 'CONGE-BC-1688', nom: 'Congélateur Solaire Coffre 1688L DC24V', prix: 1890400, litres: 1688, type: 'congelateur', puissance: 271 },
  { ref: 'FRIGO-SG-SC175', nom: 'Vitrine Réfrigérée Solaire 175L DC/AC',            prix: 425800,  litres: 175, type: 'vitrine',     puissance: 90  },
  { ref: 'FRIGO-SG-SC218', nom: 'Vitrine Réfrigérée Solaire 218L DC/AC',            prix: 466700,  litres: 218, type: 'vitrine',     puissance: 95  },
  { ref: 'FRIGO-SG-SC318', nom: 'Vitrine Réfrigérée Solaire 318L DC/AC',            prix: 556900,  litres: 318, type: 'vitrine',     puissance: 100 },
  { ref: 'GLACE-IM-30',    nom: 'Machine à Glace Solaire 30kg/jour DC24V',          prix: 618200,  litres: 0,   type: 'glace',      puissance: 165 },
];

const KIT_COMPOSANTS = {
  panneau:  { ref: 'JKM545M-72HL4-BDVP', nom: 'Panneau Jinko Tiger Neo 545Wc', prix: 152220 },
  gel65:    { ref: 'GEL-65AH-12V',       nom: 'Batterie GEL 12V 65Ah',         prix: 175600 },
  gel200:   { ref: 'GEL-200AH-12V',      nom: 'Batterie GEL 12V 200Ah',        prix: 235200 },
  mppt20:   { ref: 'MPPT-1224V-20A',     nom: 'Régulateur MPPT 12/24V 20A',    prix: 25500  },
  mppt30:   { ref: 'MPPT-1224V-30A',     nom: 'Régulateur MPPT 12/24V 30A',    prix: 32500  },
  mppt40:   { ref: 'MPPT-1224V-40A',     nom: 'Régulateur MPPT 12/24V 40A',    prix: 41800  },
  install:  { ref: 'PRESTA-INSTALL-PV',  nom: 'Installation et mise en service', prix: 35000 },
};

const getKit = (litres, type) => {
  if (type === 'glace' || (litres >= 268 && litres < 508)) {
    return { panneau: { ...KIT_COMPOSANTS.panneau, quantite: 1 }, batterie: { ...KIT_COMPOSANTS.gel200, quantite: 2 }, mppt: { ...KIT_COMPOSANTS.mppt30, quantite: 1 }, install: { ...KIT_COMPOSANTS.install, quantite: 1 } };
  } else if (litres >= 508 && litres < 800) {
    return { panneau: { ...KIT_COMPOSANTS.panneau, quantite: 2 }, batterie: { ...KIT_COMPOSANTS.gel200, quantite: 2 }, mppt: { ...KIT_COMPOSANTS.mppt40, quantite: 1 }, install: { ...KIT_COMPOSANTS.install, quantite: 1 } };
  } else if (litres >= 800) {
    return { panneau: { ...KIT_COMPOSANTS.panneau, quantite: 3 }, batterie: { ...KIT_COMPOSANTS.gel200, quantite: 4 }, mppt: { ...KIT_COMPOSANTS.mppt40, quantite: 1 }, install: { ...KIT_COMPOSANTS.install, quantite: 1 } };
  } else if (litres >= 158) {
    return { panneau: { ...KIT_COMPOSANTS.panneau, quantite: 1 }, batterie: { ...KIT_COMPOSANTS.gel200, quantite: 1 }, mppt: { ...KIT_COMPOSANTS.mppt20, quantite: 1 }, install: { ...KIT_COMPOSANTS.install, quantite: 1 } };
  } else {
    return { panneau: { ...KIT_COMPOSANTS.panneau, quantite: 1 }, batterie: { ...KIT_COMPOSANTS.gel65, quantite: 1 }, mppt: { ...KIT_COMPOSANTS.mppt20, quantite: 1 }, install: { ...KIT_COMPOSANTS.install, quantite: 1 } };
  }
};

const DimensionnementFrigoModal = ({ onClose, onGenererDevis }) => {
  const [type, setType] = useState('frigo-conge');
  const [showIA, setShowIA] = useState(false);
  const [promptIA, setPromptIA] = useState('');
  const [loadingIA, setLoadingIA] = useState(false);
  const [litres, setLitres] = useState('');
  const [quantite, setQuantite] = useState(1);
  const [produits, setProduits] = useState(PRODUITS_BASE);
  const [composants, setComposants] = useState(KIT_COMPOSANTS);
  const [compNomDB, setCompNomDB] = useState({});
  const [selectionne, setSelectionne] = useState(null);

  const analyserIA = async () => {
    if (!promptIA.trim()) return;
    setLoadingIA(true);
    try {
      const res = await fetch('https://api.groq.com/openai/v1/chat/completions', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer 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' },
        body: JSON.stringify({
          model: 'llama-3.3-70b-versatile',
          messages: [{ role: 'system', content: 'Tu es un expert en réfrigération solaire. Analyse la description et retourne UNIQUEMENT un JSON: {"type": "frigo|congelateur|frigo-conge|vitrine", "litres": number, "quantite": number}.' }, { role: 'user', content: promptIA }],
          temperature: 0.1, max_tokens: 200
        })
      });
      const data = await res.json();
      let content = data.choices?.[0]?.message?.content || '{}';
      content = content.replace(/```json/g,'').replace(/```/g,'').trim();
      const parsed = JSON.parse(content);
      if (parsed.type) setType(parsed.type);
      if (parsed.litres) setLitres(String(parsed.litres));
      if (parsed.quantite) setQuantite(parsed.quantite);
      setShowIA(false); setPromptIA('');
    } catch(e) { console.error('IA frigo:', e); }
    setLoadingIA(false);
  };

  useEffect(() => {
    supabase.from('catalogue_produits')
      .select('ref,nom,prix')
      .in('ref', [
        ...PRODUITS_BASE.map(p => p.ref),
        'JKM545M-72HL4-BDVP','GEL-65AH-12V','GEL-200AH-12V',
        'MPPT-1224V-20A','MPPT-1224V-30A','PRESTA-INSTALL-PV',
        'ACC-CABLE-SOL-DC-25MM','ACC-CABLE-DC-6MM2','MC4','GOULOTTE-40x20','COLLIERS-PLASTIQUES','KIT-CHEVILLES-VIS','DISJONCTEUR-DIFF-2P40','BOITE-DERIVATION-IP65','SUP-ALU-REGL','LESTAGE-PV-BETON'
      ])
      .eq('actif', true)
      .then(({ data }) => {
        if (!data) return;
        const map = {};
        data.forEach(p => { map[p.ref] = p; });
        setProduits(prev => prev.map(p => map[p.ref] ? { ...p, nom: map[p.ref].nom || p.nom, prix: map[p.ref].prix } : p));
        setComposants(prev => {
          const updated = { ...prev };
          Object.keys(updated).forEach(k => {
            if (map[updated[k].ref]) updated[k] = { ...updated[k], nom: map[updated[k].ref].nom || updated[k].nom, prix: map[updated[k].ref].prix };
          });
          return updated;
        });
        const cn = {}; data.forEach(p => { cn[p.ref] = p.nom; }); setCompNomDB(cn);
      });
  }, []);

  const produitsFiltres = produits.filter(p => p.type === type);

  const selectionnerAuto = () => {
    if (type === 'glace') { setSelectionne(produits.find(p => p.type === 'glace')); return; }
    const l = parseInt(litres);
    if (!l || l <= 0) return;
    const candidats = produitsFiltres.filter(p => p.litres >= l);
    setSelectionne(candidats.length > 0
      ? candidats.reduce((min, p) => p.litres < min.litres ? p : min)
      : produitsFiltres[produitsFiltres.length - 1]);
  };

  const kit = selectionne ? getKit(selectionne.litres, selectionne.type) : null;

  const totalKit = selectionne && kit
    ? (selectionne.prix * quantite)
      + kit.panneau.prix * kit.panneau.quantite * quantite
      + kit.batterie.prix * kit.batterie.quantite * quantite
      + kit.mppt.prix * kit.mppt.quantite * quantite
      + kit.install.prix
    : 0;

  const genererDevis = () => {
    if (!selectionne || !kit) return;
    const articles = [];
    let uid = 0;
    articles.push({
      _uid: uid++, _titre: true,
      description: 'KIT RÉFRIGÉRATION SOLAIRE TAKOUSSANE ENERGY | ' + (PRODUITS_BASE.find(p => p.ref === selectionne.ref)?.nom || selectionne.ref).toUpperCase() + (quantite > 1 ? ' x' + quantite : ''),
      quantity: null, unitPrice: null, image: null,
    });
    articles.push({
      _uid: uid++,
      description: selectionne.nom + '\nRef: ' + selectionne.ref + '\nDC 12/24V + Adaptateur AC inclus — Réfrigérant R134a ',
      quantity: quantite, unitPrice: selectionne.prix,
      image: getProductImage(selectionne.ref),
    });
    articles.push({
      _uid: uid++,
      description: (Object.values(composants).find(c => c.ref === kit.panneau.ref)?.nom || kit.panneau.nom) + '\nRef: ' + kit.panneau.ref,
      quantity: kit.panneau.quantite * quantite, unitPrice: kit.panneau.prix,
      image: getProductImage(kit.panneau.ref),
    });
    articles.push({
      _uid: uid++,
      description: (Object.values(composants).find(c => c.ref === kit.batterie.ref)?.nom || kit.batterie.nom) + '\nRef: ' + kit.batterie.ref,
      quantity: kit.batterie.quantite * quantite, unitPrice: kit.batterie.prix,
      image: getProductImage(kit.batterie.ref),
    });
    articles.push({
      _uid: uid++,
      description: (Object.values(composants).find(c => c.ref === kit.mppt.ref)?.nom || kit.mppt.nom) + '\nRef: ' + kit.mppt.ref,
      quantity: kit.mppt.quantite * quantite, unitPrice: kit.mppt.prix,
      image: getProductImage(kit.mppt.ref),
    });
    const nbPanFrigo = kit.panneau.quantite * quantite;
    [
      { ref: 'ACC-CABLE-SOL-DC-25MM', nom: 'Câble solaire DC 25mm²',           quantite: 10,                        prix: 3380  },
      { ref: 'ACC-CABLE-DC-6MM2',     nom: 'Câble DC 6mm²',                    quantite: (nbPanFrigo * 2 + 10) * 2, prix: 1710  },
      { ref: 'MC4',                   nom: 'Connecteur MC4 Male/Femelle',      quantite: 2 * nbPanFrigo,            prix: 2230  },
      { ref: 'GOULOTTE-40x20',        nom: 'Goulotte PVC 40x20mm (L3m)',      quantite: nbPanFrigo,                prix: 12300 },
      { ref: 'COLLIERS-PLASTIQUES',   nom: 'Lot colliers attachés',             quantite: 1,                         prix: 9250  },
      { ref: 'KIT-CHEVILLES-VIS',     nom: 'Kit chevilles et vis n8',          quantite: 1,                         prix: 2150  },
      { ref: 'DISJONCTEUR-DIFF-2P40', nom: 'Disjoncteur Schneider 2P40',      quantite: 1,                         prix: 30840 },
      { ref: 'BOITE-DERIVATION-IP65', nom: 'Boîtes dérivation IP65 x2',        quantite: 1,                         prix: 2200  },
      { ref: 'LESTAGE-PV-BETON',     nom: 'Dispositif lestage supports PV',   quantite: nbPanFrigo * 3,   prix: 6410  },
      { ref: 'SUP-ALU-REGL',         nom: 'Kit supports PV réglables (jambes)', quantite: nbPanFrigo,              prix: 25120 },
    ].forEach(comp => articles.push({ _uid: uid++, description: (compNomDB[comp.ref] || comp.nom) + '\nRef: ' + comp.ref, quantity: comp.quantite, unitPrice: comp.prix, image: getProductImage(comp.ref) }));
    articles.push({ _uid: uid++, description: (Object.values(composants).find(c => c.ref === kit.install.ref)?.nom || kit.install.nom), quantity: 1, unitPrice: kit.install.prix, image: getProductImage(kit.install.ref) });
    onGenererDevis(articles);
    onClose();
  };

  return (
    <motion.div
      initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 70, padding: '16px' }}
      onClick={function(e) { if (e.target === e.currentTarget) onClose(); }}
    >
      <motion.div
        initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
        style={{ background: 'white', borderRadius: '16px', width: '100%', maxWidth: '860px', maxHeight: '92vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 60px rgba(0,0,0,0.25)' }}
      >
        <div style={{ background: 'linear-gradient(135deg, #0891b2, #0e7490)', padding: '20px 24px', borderRadius: '16px 16px 0 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <div style={{ color: 'white', fontWeight: 700, fontSize: '18px' }}>Réfrigération & Congélation Solaire</div>
            <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: '12px', marginTop: '2px' }}>Kit complet panneau + batterie + régulateur</div>
          </div>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}><button onClick={() => setShowIA(!showIA)} style={{ background: showIA ? 'linear-gradient(135deg,#7c3aed,#a855f7)' : 'white', border: 'none', borderRadius: '8px', padding: '6px 14px', color: showIA ? 'white' : '#7c3aed', fontSize: '12px', fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}>✨ IA</button><button onClick={onClose} style={{ background: 'transparent', border: 'none', color: 'white', cursor: 'pointer', padding: '6px', display: 'flex' }}><X size={20} /></button></div>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px', display: 'flex', flexDirection: 'column', gap: '20px' }}>

          <div>
            {showIA && (<div style={{ background: 'linear-gradient(135deg,#f5f3ff,#ede9fe)', border: '1px solid #c4b5fd', borderRadius: '12px', padding: '16px', marginBottom: '16px' }}><div style={{ fontWeight: 700, fontSize: '13px', color: '#5b21b6', marginBottom: '4px' }}>✨ Décris le projet, l'IA s'occupe du reste</div><div style={{ fontSize: '11px', color: '#7c3aed', marginBottom: '10px' }}>Ex: 2 frigos-congélateurs 150L pour restaurant à Saint-Louis</div><textarea value={promptIA} onChange={e => setPromptIA(e.target.value)} rows={2} placeholder="Décris le besoin en réfrigération..." style={{ width: '100%', boxSizing: 'border-box', border: '1px solid #c4b5fd', borderRadius: '8px', padding: '8px', fontSize: '13px', outline: 'none', background: 'white', resize: 'none', fontFamily: 'inherit' }} /><button onClick={analyserIA} disabled={loadingIA || !promptIA.trim()} style={{ marginTop: '8px', width: '100%', padding: '9px', background: loadingIA ? '#a78bfa' : 'linear-gradient(135deg,#7c3aed,#a855f7)', border: 'none', borderRadius: '8px', color: 'white', fontSize: '13px', fontWeight: 700, cursor: loadingIA ? 'wait' : 'pointer' }}>{loadingIA ? '⏳ Analyse...' : '✨ Analyser'}</button></div>)}
            <label style={{ fontWeight: 700, fontSize: '14px', color: '#1f2937', display: 'block', marginBottom: '10px' }}>Type d'appareil</label>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px' }}>
              {TYPES.map(t => (
                <button key={t.key} onClick={() => { setType(t.key); setSelectionne(null); setLitres(''); }}
                  style={{ padding: '12px', textAlign: 'left', border: '2px solid ' + (type === t.key ? '#0891b2' : '#e5e7eb'), borderRadius: '10px', background: type === t.key ? '#ecfeff' : 'white', cursor: 'pointer' }}>
                  <div style={{ fontWeight: 700, fontSize: '13px', color: type === t.key ? '#0891b2' : '#374151' }}>{t.icon} {t.label}</div>
                  <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '3px' }}>{t.desc}</div>
                </button>
              ))}
            </div>
          </div>

          {type !== 'glace' && (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              <div>
                <label style={{ fontWeight: 700, fontSize: '14px', color: '#1f2937', display: 'block', marginBottom: '8px' }}>Capacité souhaitée (litres)</label>
                <input type="number" value={litres} min="1" onChange={e => { setLitres(e.target.value); setSelectionne(null); }}
                  placeholder="Ex: 150"
                  style={{ width: '100%', boxSizing: 'border-box', border: '2px solid #e5e7eb', borderRadius: '8px', padding: '10px 12px', fontSize: '16px', outline: 'none', fontWeight: 600 }}
                  onFocus={e => e.target.style.borderColor='#0891b2'}
                  onBlur={e => e.target.style.borderColor='#e5e7eb'}
                />
              </div>
              <div>
                <label style={{ fontWeight: 700, fontSize: '14px', color: '#1f2937', display: 'block', marginBottom: '8px' }}>Quantité</label>
                <input type="number" value={quantite} min="1" onChange={e => setQuantite(parseInt(e.target.value) || 1)}
                  style={{ width: '100%', boxSizing: 'border-box', border: '2px solid #e5e7eb', borderRadius: '8px', padding: '10px 12px', fontSize: '16px', outline: 'none' }}
                  onFocus={e => e.target.style.borderColor='#0891b2'}
                  onBlur={e => e.target.style.borderColor='#e5e7eb'}
                />
              </div>
            </div>
          )}

          <button onClick={selectionnerAuto}
            style={{ background: '#0891b2', color: 'white', border: 'none', borderRadius: '8px', padding: '12px 20px', fontSize: '14px', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', alignSelf: 'flex-start' }}>
            <Zap size={16} /> {type === 'glace' ? 'Sélectionner la machine à glace' : 'Trouver le modèle adapté'}
          </button>

          {selectionne && kit && (
            <div style={{ background: '#ecfeff', border: '2px solid #67e8f9', borderRadius: '12px', padding: '16px' }}>
              <div style={{ fontWeight: 700, fontSize: '14px', color: '#0e7490', marginBottom: '12px' }}>✅ Kit sélectionné — {selectionne.ref}</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {[
                  { nom: selectionne.nom, ref: selectionne.ref, qte: quantite, prix: selectionne.prix },
                  { nom: kit.panneau.nom, ref: kit.panneau.ref, qte: kit.panneau.quantite * quantite, prix: kit.panneau.prix },
                  { nom: kit.batterie.nom, ref: kit.batterie.ref, qte: kit.batterie.quantite * quantite, prix: kit.batterie.prix },
                  { nom: kit.mppt.nom, ref: kit.mppt.ref, qte: kit.mppt.quantite * quantite, prix: kit.mppt.prix },
                  { nom: kit.install.nom, ref: kit.install.ref, qte: 1, prix: kit.install.prix },
                ].map((item, i) => (
                  <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 60px 100px 110px', gap: '8px', alignItems: 'center', background: 'white', borderRadius: '8px', padding: '8px 12px', border: '1px solid #a5f3fc' }}>
                    <div style={{ fontSize: '12px', color: '#374151' }}>{item.nom}</div>
                    <div style={{ textAlign: 'center', fontSize: '13px', fontWeight: 700 }}>{item.qte}</div>
                    <div style={{ textAlign: 'right', fontSize: '12px', color: '#6b7280' }}>{fmt(item.prix)} F</div>
                    <div style={{ textAlign: 'right', fontSize: '13px', fontWeight: 700, color: '#0891b2' }}>{fmt(item.prix * item.qte)} F</div>
                  </div>
                ))}
              </div>
              <div style={{ marginTop: '12px', background: '#0891b2', borderRadius: '8px', padding: '10px 14px', display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: 'white', fontWeight: 700 }}>Total kit estimé</span>
                <span style={{ color: 'white', fontWeight: 800, fontSize: '16px' }}>{fmt(totalKit)} FCFA</span>
              </div>
            </div>
          )}

          {produitsFiltres.length > 0 && (
            <div>
              <div style={{ fontWeight: 700, fontSize: '13px', color: '#374151', marginBottom: '8px' }}>Ou choisir manuellement :</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', maxHeight: '180px', overflowY: 'auto' }}>
                {produitsFiltres.map(p => (
                  <button key={p.ref} onClick={() => setSelectionne(p)}
                    style={{ padding: '10px 14px', textAlign: 'left', border: '1px solid ' + (selectionne?.ref === p.ref ? '#0891b2' : '#e5e7eb'), borderRadius: '8px', background: selectionne?.ref === p.ref ? '#ecfeff' : 'white', cursor: 'pointer', display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ fontSize: '13px', color: selectionne?.ref === p.ref ? '#0891b2' : '#374151', fontWeight: selectionne?.ref === p.ref ? 700 : 400 }}>
                      {p.litres > 0 ? p.litres + 'L' : '30kg/j'} — {p.ref}
                    </span>
                    <span style={{ fontSize: '13px', fontWeight: 700, color: '#0891b2' }}>{fmt(p.prix)} FCFA</span>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        <div style={{ padding: '14px 24px', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', background: '#f8fafc', borderRadius: '0 0 16px 16px' }}>
          <button onClick={onClose} style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '8px 18px', fontSize: '13px', cursor: 'pointer' }}>Fermer</button>
          <button onClick={genererDevis} disabled={!selectionne}
            style={{ background: selectionne ? '#10b981' : '#e5e7eb', color: selectionne ? 'white' : '#9ca3af', border: 'none', borderRadius: '8px', padding: '8px 20px', fontSize: '13px', fontWeight: 600, cursor: selectionne ? 'pointer' : 'default' }}>
            Générer le devis
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default DimensionnementFrigoModal;
